module.exports = __webpack_public_path__ + "media/components/Influencers/Oauths/New/StepPage/step1_6-f5e063bb78a8211dd0139a1565bec663.png";